module.exports = __webpack_public_path__ + "img/20210223_CellResearch.f0e01051.png";